<svelte:options
  customElement={{
    tag: "oc-divider-v1",
    /*                       */
    extend: window.__components.extend(),
    props: {
      variant: { type: "String" },
      orientation: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./DividerV1.types.js";

  let { orientation = "horizontal", variant = "solid" }: Props = $props();
</script>

<div
  class="divider"
  class:divider--vertical={orientation === "vertical"}
  style:--border-style={variant}
></div>

<style lang="scss" global>
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";

  :host {
    --border-style: unset;
    display: block;
    width: inherit;
  }

  :host([orientation="vertical"]) {
    height: inherit;
  }

  .divider {
    display: block;
    width: 100%;
    outline: 1px var(--border-style) tokens.$oc-component-divider-border-color;
    transform: scaleY(0.5);

    &--vertical {
      width: 0;
      height: 100%;
      transform: scaleX(0.5);
    }
  }
</style>
